<template>
	<div>
		<RelatoriosDialog :dialog="dialogRelatorioDialog" :rela_id="rela_id"
			@dialogCloseRelatorioDialog="dialogCloseRelatorioDialog" />

		<v-card>
			<v-card-title> <v-icon color="primary" left>mdi-file-chart</v-icon>Central de Relatórios </v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="12" md="9">
						<v-text-field v-model="search" append-icon="search" label="Pesquisar pelo nome do relatório"
							single-line hide-details></v-text-field>
					</v-col>
					<v-col cols="12" md="3">
						<v-btn class="white--text" color="primary" elevation="9" width="100%"
							@click="dialogOpenNovoRelatorioDialog()" large>
							<v-icon left> mdi-plus </v-icon>
							Novo Relatório
						</v-btn>
					</v-col>
				</v-row>
				<v-data-table :headers="headers" :items="relatorios" class="elevation-1" :loading="loading"
					:search="search">
					<template v-slot:[`item.rela_descricao`]="{ item }">
						<div @click.stop="relatorioSelected(item)">{{ item.rela_descricao }}</div>
					</template>

					<template v-slot:[`item.created_at`]="{ item }">
						<span>
							{{ item.created_at ? new Date(item.created_at).toLocaleString('pt-BR') :
								'-' }}
						</span>
					</template>

					<template v-slot:[`item.actions`]="{ item }">
						<v-btn class="text-none" size="small" text color="primary" icon
							@click="editarRelmodelosClick(item)">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
						<v-btn class="text-none" size="small" text color="error" icon
							@click="excluirRelmodelosClick(item)">
							<v-icon>delete</v-icon>
						</v-btn>
					</template>

				</v-data-table>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>

import { mapGetters } from 'vuex'
import RelatoriosDialog from '../components/centralRelatorios/RelatoriosDialog.vue'
import { RelatoriosService } from '../services/reports/relatoriosService.js';
const relatoriosService = new RelatoriosService();

export default {
	components: {
		RelatoriosDialog
	},
	data: function () {
		return {
			relatorios: [],
			search: '',
			headers: [
				{ text: 'Nome', value: 'rela_descricao' },
				{ text: 'Criado em:', value: 'created_at', align: 'start' },
				{ text: 'actions', value: 'actions' },
			],
			dialogNovoRelatorioDialog: false,
			dialogRelatorioDialog: false,
			loading: false,
			rela_id: '',
		}
	},
	computed: {
		...mapGetters(['userRelatoriosPadroes', 'userMaster']),
	},
	methods: {
		async loadRelatorios() {
			try {
				this.loading = true
				this.relatorios = await relatoriosService.getAll()
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		loadRelatoriosSearch() {
			this.loadRelatorios()
		},
		async relatorioSelected(relatorio) {
			this.rela_id = relatorio.rela_id
			this.dialogRelatorioDialog = true
		},
		async editarRelmodelosClick(relatorio) {
			this.rela_id = relatorio.rela_id
			this.dialogRelatorioDialog = true
		},
		async excluirRelmodelosClick(relatorio) {
			const confirmou = await this.$root.$confirm(
				'Exclusão',
				'Deseja realmente excluir?',
			);

			if (!confirmou) return;

			const confirmou2 = await this.$root.$confirm_alert(
				'Confirmação',
				'Tem certeza que deseja prosseguir com a exclusão?',
			);
			if (!confirmou2) return;

			await relatoriosService.remove(relatorio.rela_id);
			this.loadRelatorios();
		},
		dialogOpenNovoRelatorioDialog() {
			this.rela_id = ""
			this.dialogRelatorioDialog = true
		},
		dialogCloseRelatorioDialog() {
			this.dialogRelatorioDialog = false
			this.loadRelatorios()
		},
	},
	mounted() {
		this.loadRelatorios()
	},
}
</script>
